import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CheckCircle2, ShieldCheck, Zap, Layers } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-6 pb-6 md:pt-10 md:pb-10 px-4 sm:px-6 lg:px-8 bg-navy-900 overflow-hidden flex flex-col items-center text-center" data-id="element-188">
      {/* Enhanced Background glow effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] md:w-[800px] h-[600px] md:h-[800px] bg-gold-500/15 rounded-full blur-[120px] pointer-events-none" data-id="element-189" />
      <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-190" />

      <div className="max-w-4xl mx-auto relative z-10 flex flex-col items-center w-full" data-id="element-191">
        {/* Top Section: Badge & Title */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center w-full" data-id="element-192">
          <div className="inline-block px-3 py-1 rounded-full bg-navy-800 border border-gold-500/30 text-gold-400 font-semibold tracking-wide mb-3 text-[11px] md:text-xs shadow-[0_0_15px_rgba(250,204,21,0.15)]" data-id="element-193">
            🏆 Sistema N°1 para Profes de Volley en Argentina
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-3 md:mb-4 drop-shadow-lg" data-id="element-194">
            PROFE DE VOLLEY{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-400 via-gold-500 to-gold-600 drop-shadow-sm" data-id="element-195">
              RESUELTO™
            </span>
          </h1>
        </motion.div>

        {/* Middle Section: Image with Glow & Floating Animation */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full flex justify-center items-center mb-3 md:mb-4" data-id="element-196">
          {/* Radial gold/warm glow behind the image */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[180px] md:w-[280px] h-[180px] md:h-[280px] bg-gold-500/30 rounded-full blur-[60px] pointer-events-none" data-id="element-197" />

          <motion.img animate={{
          y: [-6, 6, -6]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} src="https://cdn.magicpatterns.com/uploads/9VY8gssRdMcYKPctjNcoJN/heylloyd-image-1776438422008-Photoroom.png" alt="Profe de Volley Resuelto Megapack" className="relative z-10 w-[60%] max-w-[180px] md:max-w-[280px] object-contain drop-shadow-2xl" data-id="element-198" />
        </motion.div>

        {/* Bottom Section: Subtitle, Description, Features & CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-col items-center w-full" data-id="element-199">
          <p className="text-lg md:text-2xl text-gray-100 font-semibold mb-2 md:mb-3 max-w-2xl" data-id="element-200">
            Todo tu año de entrenamientos de volley resuelto.
          </p>

          <p className="text-sm md:text-base text-gray-400 mb-4 md:mb-5 max-w-xl leading-relaxed" data-id="element-201">
            Planificación, técnica, evaluación, gestión, preparación física y
            mucho más. Sin improvisar nunca más.
          </p>

          <div className="grid grid-cols-2 gap-x-3 gap-y-2 md:gap-x-6 md:gap-y-2 mb-5 md:mb-6 w-full max-w-xl" data-id="element-202">
            <div className="flex items-center justify-start md:justify-center gap-1.5 text-gray-300 text-xs md:text-sm bg-navy-800/40 py-1.5 px-3 rounded-lg border border-navy-700/50" data-id="element-203">
              <CheckCircle2 className="w-4 h-4 text-gold-500 flex-shrink-0" data-id="element-204" />
              <span className="font-medium" data-id="element-205">PDF digital</span>
            </div>
            <div className="flex items-center justify-start md:justify-center gap-1.5 text-gray-300 text-xs md:text-sm bg-navy-800/40 py-1.5 px-3 rounded-lg border border-navy-700/50" data-id="element-206">
              <Zap className="w-4 h-4 text-gold-500 flex-shrink-0" data-id="element-207" />
              <span className="font-medium" data-id="element-208">Acceso inmediato</span>
            </div>
            <div className="flex items-center justify-start md:justify-center gap-1.5 text-gray-300 text-xs md:text-sm bg-navy-800/40 py-1.5 px-3 rounded-lg border border-navy-700/50" data-id="element-209">
              <Layers className="w-4 h-4 text-gold-500 flex-shrink-0" data-id="element-210" />
              <span className="font-medium" data-id="element-211">Todas las categorías</span>
            </div>
            <div className="flex items-center justify-start md:justify-center gap-1.5 text-gray-300 text-xs md:text-sm bg-navy-800/40 py-1.5 px-3 rounded-lg border border-navy-700/50" data-id="element-212">
              <ShieldCheck className="w-4 h-4 text-gold-500 flex-shrink-0" data-id="element-213" />
              <span className="font-medium" data-id="element-214">Garantía 7 días</span>
            </div>
          </div>

          <div className="w-full max-w-sm mx-auto" data-id="element-215">
            <Button size="xl" fullWidth onClick={scrollToPricing} className="animate-pulse-slow shadow-[0_0_30px_rgba(250,204,21,0.25)] hover:shadow-[0_0_40px_rgba(250,204,21,0.4)] transition-shadow duration-300" data-id="element-216">
              💥 QUIERO MI PROFE DE VOLLEY RESUELTO
            </Button>
            <p className="text-center text-xs text-gray-400 mt-2.5 flex items-center justify-center gap-1.5" data-id="element-217">
              <ShieldCheck className="w-3.5 h-3.5 text-gold-500" data-id="element-218" /> Pago 100%
              seguro · Mercado Pago | Tarjeta | Transferencia
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}